const ngHeader = [() => {
    return {
        /**
         * @param $scope
         * @param $item
         * @param $params {{ ngHeader }}
         */

        link: function ( $scope, $item, $params ) {
            let $old = 0;
            let $new = 0;
            window.addEventListener('scroll', (event) =>{
                $new = window.pageYOffset || document.documentElement.scrollTop;
                // Scrolling direction

                $item[0].dataset.scroll  = $old < $new || $new < $item[0].offsetHeight ? 'down' : 'up';
                // Overwrite when hamburger is opened
                if ( $scope.modules.display.mobileLeftSidebar === true ) {
                    $item[0].dataset.scroll = "up";
                }
                // Reset the old value
                $old = $new;
            }, { capture: true, passive: true });
        }
    }
}];
export default ngHeader;
